/// <reference path="../../../../typings/index.d.ts" />
///<reference path="../../components/models/meevo.model.custom.ts"/>
///<reference path="../../components/baseClasses/guid.ts"/>
///<reference path="../../components/models/meevo.dtos.d.ts"/>
///<reference path="system-tags/system-tags.ts"/>


module Meevo.Plugins.DocsAndForms {

    import AppAreaEnum = Meevo.Model.AppAreaEnum;
    import ControlTypeEnum = Meevo.Model.ControlTypeEnum;
    import DocsAndFormsTriggerEventEnum = Meevo.Model.DocsAndFormsTriggerEventEnum;
    import IUserDefinedControlAnswer = Meevo.Model.IUserDefinedControlAnswer;
    import IUserDefinedControlValue = Meevo.Model.IUserDefinedControlValue;
    import MeevoFile = Meevo.Model.MeevoFile;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import DeliveryMethodEnum = Meevo.Plugins.Egifts.DeliveryMethodEnum;
    import AppointStateEnum = Meevo.Model.AppointStateEnum;
    import AppointFinalStateEnum = Meevo.Model.AppointFinalStateEnum;

    export enum DocsAndFormsLifeSpanEnum {
        Months = 30573,
        Days = 30574
    }

    export enum FormAndDocsAppointment {
        Booked = 30519,
        CheckedIn = 30520,
        CheckedOut = 30521
    }

    export enum FormAndDocsView {
        OnlyOnce = 10020,
        EveryTime = 10021,
        Membership = 11045796,
        PaymentPlan = 11045912,
    }

    export enum FormAndDocsDelivery {
        TextMessage = 30522,
        Email = 30523,
        TextAndEmail = 30524,
        DoNotSend = 30584
    }

    export enum FormFillTypeEnum {
        OnlyOnce = 10020,
        EveryTime = 10021,
        Membership = 11045796,
        PaymentPlan = 11045912,
        All = 1
    }

    export interface IFormServiceConfig {
        appointmentServiceId: string;
        hasForms: boolean;
        hasUnsubmittedForms: boolean;
        hasRequiredForms: boolean;
        hasRequiredUnsubmittedForms: boolean;
    }
    export enum DocsAndFormsCreationTypeEnum {
        CustomHtmlUpload = 11045157,
        WYSIWYG = 11045158,
    }

    export interface IGroupedByServiceForm {
        appointmentServiceId: string;
        startDateTime: string | Date;
        serviceDisplayName: string;
        serviceId: string;
        forms: IClientFormService[];
    }

    export interface IShowFormOptionRow {
        formId: string;
        formDisplayName: string;
        formUrl: string;
        serviceId: string;
    }

    export interface IClientForm {
        deliveryMethodEnum: FormAndDocsDelivery;
        formId: string;
        displayName: string;
        serviceDateTime: string;
        services: IClientFormService[];
        requiresAttention: boolean;
        lastSentDate: string | Date;
        securityKey?: string;
    }

    export interface IClientFormService {
        id: string;
        formId: string;
        tabTypeEnum: Meevo.Model.FormTypeEnum;
        clientId: string;
        clientFirstName: string;
        clientLastName: string;
        appointmentServiceId: string;
        appointmentId: string;
        serviceDateTime: string;
        serviceDisplayName: string;
        serviceShortcut: string;
        displayName: string;
        formFillTypeEnum: FormAndDocsView;
        formAssociatedDate: string;
        triggerEventEnum: number;
        formUrl: string;
        expirationDate?: string;
        isPrompted: boolean;
        isRequired: boolean;
        oncePerDaySubmission: boolean;
        dateCreated: string;
        dateUpdated?: string;
        pdfUrlHistoryList: IPdfUrlHistory[];
        livePDFUrlHistoryList: IPdfUrlHistory[];
        isOwner?: boolean;
        locationId?: number;
        isSubmitted: boolean;
        lastSentDate: string;
        lastSubmittedDate: string;
        url?: string;
        appointmentServiceFinalState?: Model.AppointFinalStateEnum;
        appointmentIsCheckedOut?: boolean;
        hasAnswers?: boolean;
        pdfUrl?: string;
        appointmentInPast?: boolean;
        service_TId?: string;
        securityKey?: string;
        appointmentServiceTransitionState?: AppointStateEnum;
        appointmentIsActive?: boolean;
    }

    export interface IPdfUrlHistory {
        tenantId: number;
        formTab_TId: string;
        formPDF_TId: string;
        client_TId: string;
        appointService_LId: string;
        dateCreated: string;
        dateUpdated: string;
        formPdfResourceObject: IFormPdfResourceObject;
    }

    export interface IFormPdfResourceObject {
        fileGuid: string;
        resourceType: number;
        contentType: string;
        meevoFile: MeevoFile;
        isStorageUpdated: boolean;
    }

    export interface IDocsAndFormsListItem {
        appointmentServiceId: string;
        clientFirstName: string;
        clientId: string;
        clientLastName: string;
        dateCreated: string;
        formFillTypeEnum: FormFillTypeEnum;
        formId: string;
        displayName: string;
        formUrl: string;
        isPrompted: boolean;
        isRequired: boolean;
        oncePerDaySubmission: boolean;
        pdfUrlHistoryList: any[];
        serviceDisplayName: string;
        serviceShortcut: string;
        triggerEventEnum: DocsAndFormsTriggerEventEnum;
    }          

    export interface IDocsAndFormsModel {
        formCreationTypeEnum?: DocsAndFormsCreationTypeEnum;
        designerConfig?: string;
        sendUponBooking: boolean;
        sendUponConfirming: boolean;
        isBuilt?: boolean;
        title: string;
        displayName: string;
        logoLink: string;
        tenantId: number;
        entityVersion: number;
        tab_TId: string;
        tabTypeEnum: Meevo.Model.FormTypeEnum; // TabTypeEnum;
        expirationDate: Date;
        isPrompted: boolean;
        deliveryMethodEnum: number; // DocsAndFormsDeliveryMethodEnum
        formFillTypeEnum: number; //FormFillTypeEnum
        formTypeLocked?: boolean;
        templateHTML: string;
        builderHTML: string;
        originalBuilderHTML: string;
        id: string;
        isRequired: boolean;
        oncePerDaySubmission: boolean;
        objectStateEnum: number;
        objectState: number;
        _objectState: number;
        triggerEventEnum: number;
        serviceList?: string[];
        membershipList?: string[];
        meevoFile?: Meevo.Model.MeevoFile;
        activeStateWasChanged: boolean;
        hasCustomField: boolean;
        pdfUrlHistoryList?: any[];
        formLifeSpanTypeEnum?: DocsAndFormsLifeSpanEnum;
        lifeSpan?: number;
        deliveryMethodText?: boolean;
        deliveryMethodEmail?: boolean;
        sendXDaysBeforeAppointment?: boolean;
        daysBeforeAppointment?: number;
        readonly hasHTML: boolean;
        readonly fillTypeChanged: boolean;
        readonly fillTypeLabel: string;
        readonly initialFillTypeLabel: string;
        readonly creationTypeChanged: boolean;
        readonly templateHTMLChanged: boolean;
        sendUponFinalizeTransaction?: boolean;
        isCopied: boolean;
        copiedFromTab_TId?: string;
    }

    export interface IFormBuilderModel {
        selectedSystemTagsNames: ISystemTag[];
        logoSrc: string;
        selectedUDFs: Meevo.Model.IUserDefinedControl[];
        assignedUDFs: IDocsAndFormAssignedCFF[];
    }

    export interface IDocsAndFormAssignedCFF extends Meevo.Model.IUserDefinedControl {
        selected: boolean;
        readonly removable: boolean;
        readonly dataStr: string;
    }

    export class DocsAndFormsModel implements IDocsAndFormsModel {

        static get FillFormTypes() {
            return [
                { value: FormFillTypeEnum.OnlyOnce, label: 'LABEL_ONLY_ONCE' },
                { value: FormFillTypeEnum.EveryTime, label: 'LABEL_EVERY_TIME' },
                { value: FormFillTypeEnum.Membership, label: 'LABEL_MEMBERSHIP_FORM' },
                { value: FormFillTypeEnum.PaymentPlan, label: 'LABEL_PAYMENTPLAN_FORM' },
            ];
        }

        public _objectState: number;
        public readonly initialFormFillTypeEnum?: FormFillTypeEnum;

        formCreationTypeEnum?: DocsAndFormsCreationTypeEnum;
        designerConfig?: string;
        sendUponBooking: boolean;
        sendUponConfirming: boolean;
        isBuilt?: boolean;
        title: string;
        displayName: string;
        logoLink: string;
        tenantId: number;
        entityVersion: number;
        tab_TId: string;
        tabTypeEnum: Meevo.Model.FormTypeEnum; // TabTypeEnum;
        expirationDate: Date;
        isPrompted: boolean;
        deliveryMethodEnum: number; // DocsAndFormsDeliveryMethodEnum
        formFillTypeEnum: FormFillTypeEnum; // FormFillTypeEnum
        formTypeLocked?: boolean;
        templateHTML: string;
        builderHTML: string;
        originalBuilderHTML: string;
        id: string;
        isRequired: boolean;
        oncePerDaySubmission: boolean;
        objectStateEnum: number;
        triggerEventEnum: number;
        serviceList?: string[];
        membershipList?: string[];

        activeStateWasChanged: boolean;
        formLifeSpanTypeEnum?: DocsAndFormsLifeSpanEnum;
        lifeSpan?: number;

        deliveryMethodText?: boolean;
        deliveryMethodEmail?: boolean;
        sendXDaysBeforeAppointment?: boolean;
        daysBeforeAppointment?: number;

        _originalFormCreationTypeEnum?: DocsAndFormsCreationTypeEnum;
        _originalTemplate?: string;
        sendUponFinalizeTransaction?: boolean;
        isCopied: boolean;
        copiedFromTab_TId?: string;
        suppressWarnings?: boolean;

        get hasCustomField(): boolean {
            return /name="[\d\w]{8}-[\d\w]{4}-[\d\w]{4}-[\d\w]{4}-[\d\w]{12}"/g.test(this.templateHTML || '');
        }

        get hasHTML() {
            return typeof this.templateHTML === 'string' && this.templateHTML.length > 0;
        }

        get objectState(): number {
            return this._objectState;
        }

        set objectState(value: number) {
            this.activeStateWasChanged = true;
            this._objectState = value;
        }

        get fillTypeChanged() {
            return this.initialFormFillTypeEnum !== this.formFillTypeEnum;
        }

        get fillTypeLabel(): string {
            return DocsAndFormsModel
                .FillFormTypes
                .find((row) =>  row.value === this.formFillTypeEnum)
                .label
        }

        get initialFillTypeLabel(): string {
            if(!this.initialFormFillTypeEnum) return '';

            return DocsAndFormsModel
                .FillFormTypes
                .find((row) =>  row.value === this.initialFormFillTypeEnum)
                .label
        }

        get creationTypeChanged(): boolean {
            return this._originalFormCreationTypeEnum && this._originalFormCreationTypeEnum !== this.formCreationTypeEnum
        }

        get templateHTMLChanged(): boolean {
            return this._originalTemplate !== this.templateHTML;
        }

        constructor(params: IDocsAndFormsModel = <IDocsAndFormsModel>{}) {
            this.templateHTML = '';
            this.builderHTML = '';
            this.originalBuilderHTML = '';
            this.logoLink = '';
            this.formCreationTypeEnum = null;
            this.initialFormFillTypeEnum = params.formFillTypeEnum;
            this._originalFormCreationTypeEnum = params.formCreationTypeEnum;
            this._originalTemplate = params.templateHTML;

            _.assign(this, params);

            this.activeStateWasChanged = !!params.id || params.objectState === ObjectStateEnum.Active;

            this.deliveryMethodText = params.deliveryMethodEnum === FormAndDocsDelivery.TextAndEmail || params.deliveryMethodEnum === FormAndDocsDelivery.TextMessage;
            this.deliveryMethodEmail = params.deliveryMethodEnum === FormAndDocsDelivery.TextAndEmail || params.deliveryMethodEnum === FormAndDocsDelivery.Email;
        }
    }

    export class DocsAndFormAssignedUDFItem implements IDocsAndFormAssignedCFF {
        control_TId: Guid;
        tab_TId: Guid;
        isMainTab: boolean;
        tabName: string;
        tenantId: number;
        locationId: number;
        controlName: string;
        displayName: string;
        promptValue: string;
        entityVersion: number;
        controlTypeEnum: ControlTypeEnum;
        appAreaEnum: AppAreaEnum;
        objectStateEnum: ObjectStateEnum;
        items: Array<IUserDefinedControlValue>;
        shortcut: string;
        isRequired: boolean;
        oncePerDaySubmission: boolean;
        isSearchable: boolean;
        createdByUserId: Guid;
        updatedByUserId: Guid;
        dateCreated: string;
        dateUpdated: string;
        sortOrder: number;
        businessTypeName: string;
        businessType_TId: Guid;
        controlServiceName: string;
        isUsed: boolean;
        answers: Array<IUserDefinedControlAnswer>;
        isIncludedInEmailNotification: boolean;
        isShowBookingOnline: boolean;
        tabTypeEnum: Meevo.Model.FormTypeEnum;
        selected: boolean;

        get removable() {
            return !this.isUsed;
        }

        get dataStr(): string {
            return encodeURI(JSON.stringify({
                appAreaEnum: this.appAreaEnum,
                name: this.control_TId
            }));
        }

        constructor(params: IDocsAndFormAssignedCFF) {
            _.assign(this, params);
        }
    }

    export class FormBuilderModel implements IFormBuilderModel {

        private _assignedUDFs: IDocsAndFormAssignedCFF[];

        public selectedSystemTagsNames: ISystemTag[];
        public logoSrc: string;

        get assignedUDFs(): IDocsAndFormAssignedCFF[] {
            return this._assignedUDFs;
        }

        set assignedUDFs(udfs: IDocsAndFormAssignedCFF[]) {
            this._assignedUDFs = <IDocsAndFormAssignedCFF[]>udfs.map(row => new DocsAndFormAssignedUDFItem(row));
        }

        get selectedUDFs(): Meevo.Model.IUserDefinedControl[] {
            return this.assignedUDFs.filter(row => row.selected);
        }

        constructor(params: IFormBuilderModel = <IFormBuilderModel>{}) {
            this._assignedUDFs = [];

            _.assign(this, params);
        }
    }
}
